<template>
  <div>
    <b-row class="py-3">
      <b-col>
        <h4>POPULAR<b>ITEMS</b></h4>
      </b-col>
    </b-row>

    <b-table
     striped
     hover
     :items="topitems"
     :fields="fields"
    >
    <template #cell(image_path)="data">
      <b-img width="75" rounded="circle" :src="data.item.image_path" :alt="data.item.item_name"></b-img>
    </template>
    </b-table>
    <b-row>
      <b-col class="pt-2" style="text-align:right;">Time Period:</b-col>
      <b-col><b-form-select v-model="selectedperiod" :options="periodopts" @input="fetchTopItems()"></b-form-select></b-col>
    </b-row>
  </div>
</template>


<script>
export default {
  name: "TopItemsTable",
  data() {
    return {
      topitems: [],
      showoverlay: false,
      selectedperiod: 'thirty',
      periodopts: [
        { value: 'thirty', text: 'Last 30 days' },
        { value: 'ninety', text: 'Last 90 days' },
        { value: 'year', text: 'Last year' },
        { value: 'all', text: 'All' },
      ],
      fields: [
          {key: 'image_path', label: 'Item', class: "item-table-images"},
          {key: 'item_name', label: '',  class: "item-table-data"},
          {key: 'num_items', label: 'Sold',  class: "item-table-data"}
      ],
    };
  },
  methods: {
    // emitPeriodChange() {
    //   this.$emit('emit-titem-period', this.selectedperiod);
    // },

    async fetchTopItems() {
      this.showoverlay = true;
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      // Use Axios to make a call to the API
      const { data } = await this.$api.get("dashboard/top-items?period="+this.selectedperiod, {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      });
      this.topitems = data.topitems.slice(0,5);
      this.showoverlay = false;
    },

  },
  created() {
    this.fetchTopItems();
  }

};
</script>
<style>
  .overspin .spinner-border {
    visibility: hidden;
  }

  .item-table-images {
    text-align: center;
    font-size: 120%;
    font-weight: bold;
  }

  .item-table-data {
    padding-top: 2rem !important;
    font-size: 120%;
    font-weight: bold;
  }

</style>
